import Vue from 'vue';
import App from './containers/App.vue';
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import UpperCase from '@/directives/uppercase'
import i18n from "@/plugins/i18n";

Vue.config.productionTip = false;

/*
* ======================================================
* Amplify INIT
* ======================================================
**/
import Amplify from 'aws-amplify';
import awsconfig from '../aws.config.json';
Amplify.configure(awsconfig);

/*
* ======================================================
* DotENV
* ======================================================
**/
// Incluimos el framework para el manejo de variables de ambiente
import dotenv from "dotenv";
// Inicializamos las variables de ambiente
dotenv.config();


/*
* ======================================================
* SCSS
* ======================================================
**/
// Incluimos hoja de estilos
import './sass/main.scss'

import { Logger } from 'aws-amplify';
const logger = new Logger('main-app-logger', process.env.VUE_APP_LOGLEVEL);


Vue.directive('uppercase', UpperCase);


/*
* ======================================================
* VuetifyTelCode
* ======================================================
**/
// Incluimos lihreria de code phone vuetify (para la UI)
// @ts-ignore
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';

Vue.use(VueTelInputVuetify, {
  vuetify,
});


store.dispatch("init").then(()=>{

  let app = new Vue({
    router,
    i18n,
    store,
    vuetify,
    render: (h) => h(App),
  });

  app.$i18n.locale = store.getters["i18n/getLocale"];

  app.$mount('#app');
})
.catch(e => {
  logger.error(`Can't init application`)
  logger.error(e)
});



